export const TW = {
  //商品区分
  COMMODITY: {
    EQUITY: 1, //現物
    MARGIN: 2, //信用
    FUTURE: 3, //先物
    OPTION: 4, //オプション
  },
  //チェックモード
  CHECK_MODE: {
    NORMAL: 1, //通常
    CHECK_ONLY: 2, //チェックのみ
  },
  //注文ステータス
  ORDER_STATE: {
    NONE: 0, //無効
    WAIT: 1, //待機
    ORDER_SENDING: 2, //発注中
    PROCESSED: 3, //発注済訂正済
    SENDING: 4, //訂正取消送信中
    FINISH: 5, //終了
    DELETED: 10, //削除
  },
  //注文詳細種別
  REC_TYPE: {
    RECEIVE: 1, //受付
    CARRY_OVER: 2, //繰越
    EXPIRE_DAY: 3, //期限切れ
    ORDER: 4, //発注
    REPLACE: 5, //訂正
    CANCEL: 6, //取消
    EXPIRE: 7, //失効
    EXECUTION: 8, //約定
    CONVERT: 9, //コンバート
    TRIGGER_REPLACE: 10, //トリガ訂正
  },
  //注文詳細ステータス
  ORDER_DETAIL_STATE: {
    WAIT: 1, //待機
    ORDER_SENDING: 2, //処理中
    PROCESSED: 3, //処理済
    ERROR: 4, //エラー
    DELETED: 5, //削除
  },
  //現物信用区分
  CASH_MARGIN: {
    CASH: 1, //現物
    OPEN: 2, //新規
    CLOSE: 3, //返済
    ACTUAL_RECEIPT: 100, //品受
    ACTUAL_DELIVER: 101, //品渡
  },
  //市場
  EXCHANGE: {
    NONE: 0, //無効
    TSE: 1, //東証
    OSE: 2, //大証
    NSE: 3, //名証
    FSE: 5, //福証
    SSE: 6, //札証
    OSE_DERIVE_DAY: 23, //大証派生日中
    OSE_DERIVE_NIGHT: 24, //大証派生夜間
    NY: 101,
    NASDAQ: 102,
    US_INDEX: 100,
    BRAZIL_INDEX: 110,
    HONG_KONG_EQUITY: 2011,
    HONG_KONG_INDEX: 2010,
    SHANGHAI: 2021,
    SHENZHEN: 2022,
    CHINA_INEDX: 2020,
    TAIWAN_EQUITY: 2031,
    TAIWAN_INEDX: 2030,
    KOSPI: 2041,
    KOSDAQ: 2042,
    KOREA_INDEX: 2040,
    SINGAPORE_EQUITY: 2051,
    SINGAPORE_INDEX: 2050,
    THAILAND_EQUITY: 2061,
    THAILAND_INDEX: 2060,
    MALAYSIA_EQUITY: 2071,
    MALAYSIA_INDEX: 2070,
    INDONESIA_EQYITY: 2081,
    INDONESIA_INDEX: 2080,
    PHILIPPINES_EQUITY: 2091,
    PHILIPPINES_INDEX: 2090,
    HO_CHI_MINH: 2101,
    HANOI: 2102,
    VIETNAM_INDEX: 2100,
    ISRAEL_EQUITY: 2111,
    ISRAEL_INDEX: 2111,
    INDEIA_INDEX: 2120,
    EXCHANGE: 400,
    BOND: 13000,
    POLICY_INTEREST_RATE: 13101,
    INDICATORS: 13102,
    CS: 14000, // 商品先物
    USF: 14100, // 米国先物
    NME: 14100, // プラチナ・パラジウム・原油先物
    LONDON_GOLD_FIXING: 14200, // ロンドン金フィキシング
    NK225_FUTURE_CME: 14106, // 日経225先物CME
  },
  //売買区分
  SIDE: {
    SELL: "1", //売
    BUY: "2", //買
  },
  //信用取引区分
  MARGIN_TRADE_TYPE: {
    NONE: 0, //無効（信用取引以外）
    GENERAL: 1, //制度信用または貸借取引
    COMPANY: 2, //一般信用（長期）
    COMPANY_SHORT: 3, //一般信用（短期）
    COMPANY_MUKI: 11, //一般信用無期限
    COMPANY_1DAY: 12, //一般信用1日
  },
  //執行条件
  ORD_TYPE: {
    NONE: 0, //無効
    ZARABA: 1, //ザラバ
    YORI: 2, //寄り
    HIKE: 3, //引け
    FUNARI: 4, //不成
    //BEST_LIMIT_ORDER: 5, //最良価格指値
    IOC: 6, //IOC
  },
  //預り区分
  FUND_TYPE: {
    NONE: "  ", //無効
    HOGO: "02", //保護
    SHINYODAIYO: "AA", //信用代用
    SYOKOKINDAIYO: "BB", //証拠金代用
  },
  //税区分
  ACCOUNT_TYPE: {
    NONE: 0, //無効
    IPPAN: 2, //一般
    TOKUTEI: 4, //特定
    NISA: 5, //NISA
  },
  //値段定数
  PRICE: {
    NARIYUKI: 0, //成行値段
    MISHITEI: -888888888888888, //未指定（例：プラマイ指値で使用する動的値段）
  },
  //値段種類
  PRICE_TYPE: {
    NONE: 0, //無効
    NARIYUKI: 1, //成行
    SASHINE: 2, //指値
    SAIDAI_SASHINE: 3, //最大指値（買いは値幅の上限で、売りは値幅の下限で出す）
    /* PriceTypeにないが発注パラメータを作るときに変換する　*/
    // SAIRYO_SASHINE: 998,
    // DOUNE: 999,
  },
  //有効期間
  TIME_IN_FORCE: {
    NONE: 0, //無効
    FOK: 1, //FillorKill 全数量が直ちに約定しない場合は、その全数量を失効させる条件
    FAK: 2, //FillandKill 一部約定後に未執行数量が残るとき、その残数量を失効させる条件
    GFD: 3, //Good for Day 当日の日中立会終了まで有効とする条件
    GTD: 4, //Good till Date 指定した期間が満了する日（の日中立会終了まで有効とする条件
    GTC: 5, //Good till Cancel 取り消すまで有効とする条件
  },
  //商品区分
  SECURITY_TYPE: {
    INDEX: 0, //指数
    EQUITY: {
      JAPAN: 1, //日本株
      US: 30, //米株
      HONG_KONG: 2011,
      CHINA: 2021,
      TAIWAN: 2031,
      KOREA: 2041,
      SINGAPORE: 2051,
      THAILAND: 2061,
      MALAYSIA: 2071,
      INDONESIA: 2081,
      PHILIPPINES: 2091,
      VIETNAM: 2101,
      ISRAEL: 2111,
      INDIA: 2121,
    },
    FUTURE: {
      NK225: 101, //NK225 先物
      NK225_MINI: 901, //NK225ミニ 先物
      TOPIX: 107, //TOPIX 先物
      TOPIX_MINI: 907, //TOPIXミニ 先物
      JPX400: 121, //JPX400 先物
      REIT: 155, //REIT 先物
      CORE30: 171, //CORE30 先物
    },
    OPTION: {
      NK225: 103, //NK225 オプション
      TOPIX: 109, //TOPIX オプション
    },
    SHARE_LESS_THAN_UNIT: 2, //単元未満株
    PUBLIC_OFFERING: 3, //IPO,PO
    EXCHANGE: 12000, // 為替
    BOND: {
      THAILAND: 13001,
      CHINA: 13002,
      JAPAN: 13003,
      HONG_KONG: 13004,
      US: 13005,
      SOUTH_AFRICA: 13006,
      KOREA: 13007,
      VIETNAM: 13008,
      RUSSIA: 13009,
      PHILIPPINES: 13010,
      INDONESIA: 13011,
      TAIWAN: 13012,
      ENGLAND: 13013,
      MALAYSIA: 13014,
      EURO: 13015,
      GERMANY: 13016,
      FRANCE: 13017,
      SINGAPORE: 13018,
      NEW_ZEALAND: 13019,
      AUSTRALIA: 13020,
      BRAZIL: 13021,
    },
    POLICY_INTEREST_RATE: 13101,
    INDICATORS: 13102,
    COMMODITY: {
      GOLD: 14001,
      SILVER: 14002,
      GOLD_NY_FUTURE: 14003,
      SILVER_NY_FUTURE: 14004,
      PLATINUM_NY_FUTURE: 14111,
      PALLADIUM_NY_FUTURE: 14112,
      WTI_CRUDE_OIL_FUTURE: 14113,
      LONDON_GOLD_FIXING: 14201,
    },
    NK225_FUTURE_CME: 14106,
  },
  //サブシステムＩＤ
  SUB_SYSTEM_ID: {
    Default: 0,
    US: 100,
  },
  //空売りフラグ
  SELLING_SHORT: {
    NONE: "0", //なし
    RESTRICTION: "5", //価格規制有
    NON_RESTRICTION: "7", //価格規制なし
  },
  //プットコール
  // PUT_OR_CALL: {
  //   NONE: 0, //無効
  //   PUT: 1, //Put
  //   CALL: 2, //Call
  // },
  //貸借区分
  LOANS_MARGIN: {
    NONE: 0, //無効
    TAISHAKU: 1, //信用買・信用売可能・貸借銘柄
    SHINYO: 2, //信用買のみ可能・制度信用銘柄
    SELL: 3, //信用売のみ可能・一般信用でのみ使用
  },
  //整理監理区分
  TEMPORATY_POST: {
    NONE: 0, //無効
    SEIRI: 1, //整理
    KANRI: 2, //監理
  },
  //品受品渡種別
  ACTUAL_DELIVERY_TYPE: {
    ACTUAL_RECEIPT: 1, //品受
    ACTUAL_DELIVERY: 2, //品渡
  },

  //注文有効期限
  EXPIREDAYS: {
    UNTIL_TRADE_END: 0, //取引最終日
    TODAY: 1, //当日
  },
  //注文結果（判定が必要な値）
  ORDER_RESULT_CODE: {
    SUCCESS: 0,
    INSIDER: 500001,
  },
  //
  RESULT_CODE: {
    SUCCESS: 0,
  },

  // 建玉ソート順
  POSITION_ORDER: {
    DATE_ASC_POL_DESC: 0,
    DATE_ASC_POL_ASC: 1,
    DATE_DESC_POL_DESC: 2,
    DATE_DESC_POL_ASC: 3,
    POL_DESC_DATE_ASC: 4,
    POL_DESC_DATE_DESC: 5,
    POL_ASC_DATE_ASC: 6,
    POL_ASC_DATE_DESC: 7,
  },

  //TODO:変数名は適当です。後で調整
  //気配種別
  QUOTE_FLAG: {
    NONE: "0000",
    IPPAN: "0101",
    TOKUBETSU: "0102",
    CHUI: "0103",
    YORIMAE: "0107",
    TEISHIMAE_TOKUBETSU: "0108",
    HIKEGO: "0109",
    YORIMAE_YAKUJYO_POINT_NASHI: "0116",
    YORIMAE_YAKUJYO_POINT_ARI: "0117",
    RENZOKU_YAKUJYO: "0118",
    TEISHIMAE_RENZOKU_YAKUJYO: "0119",
    KAIAGARI_URIAGARI: "0120",
  },

  FONTS: [
    {
      value: "font-Roboto",
      name: "Roboto",
      os: {
        win32: true,
        darwin: true,
      },
    },
    {
      value: "font-notosans",
      name: "NotoSans",
      os: {
        win32: true,
        darwin: true,
      },
    },
    {
      value: "font-yugothic",
      name: "游ゴシック",
      os: {
        win32: true,
        darwin: true,
      },
    },
    {
      value: "font-Helvetica",
      name: "Helvetica",
      os: {
        win32: false,
        darwin: true,
      },
    },
    {
      value: "font-Arial",
      name: "Arial",
      os: {
        win32: true,
        darwin: true,
      },
    },
    //Mac最新OSでヒラギノ角ゴが対応から外れる為一旦削除
    // {
    //   value: 'font-Hiragino',
    //   name: 'Hiragino Kaku Gothic Pro',
    //   os: {
    //     win32: false,
    //     darwin: true,
    //   },
    // },
    {
      value: "font-MSgothic",
      name: "MSゴシック",
      os: {
        win32: true,
        darwin: true,
      },
    },
  ],

  THEMES: [
    {
      value: "white",
      name: "White",
      className: "white",
    },
    {
      value: "dark",
      name: "Dark",
      className: "dark",
    },
    {
      value: "gold",
      name: "Gold",
      className: "dark gold",
    },
    {
      value: "green",
      name: "Green",
      className: "dark green",
    },
    {
      value: "blue",
      name: "Blue",
      className: "dark blue",
    },
  ],

  SCREEN_FONT_SIZE: [
    {
      value: "xlarge",
      name: "特大",
      scale: 1.45,
      className: "xl",
    },
    {
      value: "large",
      name: "大",
      scale: 1.18,
      className: "l",
    },
    {
      value: "normal",
      name: "中",
      scale: 1,
      className: "m",
    },
    {
      value: "small",
      name: "小",
      scale: 0.9,
      className: "s",
    },
  ],
  NOTIFY_FILTER_TYPE: {
    ALL: { id: "all", name: "全てのお知らせ" },
    UNREAD: { id: "unread", name: "未読のみ" },
    READ: { id: "read", name: "既読のみ" },
  },
  TRADE_PASSWORD_SAVE_TYPE: {
    NOT_SAVE: 0, // 保存しない
    WHILE_APP_ACTIVE: 1, // アプリケーションを終了するまで取引暗証番号を省略する
    Ever: 2, // 常に保存する
  },

  ORDER_ROUTES: {
    ORDER_PANEL: "OrderPanel",
    ORDER_BOARD: "OrderBoard",
    ORDER_SPEED: "OrderSpeed",
    ORDER_BASKET: "OrderBasket",
  },
  // Versionチェック結果
  STARTUP_DECISION: {
    NO_UPDATE: 0, //更新なし
    USER_UPDATE: 1, //任意更新
    REQUIRED_UPDATE: 2, //必須更新
    NO_LOGIN: 3, //強制停止
  },

  SELECT_CANCEL_ERR_MESSAGES: {
    DEFAULT:
      "取消に失敗した注文があります。注文約定照会から注文状況をご確認ください。",
    NO_ORDERS: "取消注文する注文番号が指定されていません。",
  },
}
